import './scripts/slickStettings';
import './design.html';
import '@fortawesome/fontawesome-free/js/fontawesome';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import './styles.scss';
const $ = require('jquery');
require('slick-carousel');
require('slick-carousel/slick/slick.css');
require('slick-carousel/slick/slick-theme.css');
import './scripts/design';
import './scripts/seo';
import './scripts/mainPage';
import './scripts/development';
import './scripts/contactUs';
import './scripts/animatedBg';
import './scripts/subscribe-form';
import './design.html';
import './contact-us.html';

library.add(fas, fab);

dom.watch();
